import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { RULE_GROUPS_ACTION_TYPE } from '../actions';

const initialState = {};

const ruleGroupsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case RULE_GROUPS_ACTION_TYPE.GET_RULE_GROUPS:
        return payload;

      case RULE_GROUPS_ACTION_TYPE.ADD_RULE_GROUP:
      case RULE_GROUPS_ACTION_TYPE.EDIT_RULE_GROUP:
      case RULE_GROUPS_ACTION_TYPE.GET_RULE_GROUP_BY_ID:
        draft[payload.id] = payload;
        break;

      case RULE_GROUPS_ACTION_TYPE.CLONE_RULE_GROUP:
        payload.forEach(ruleGroup => {
          draft[ruleGroup.id] = ruleGroup;
        });
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default ruleGroupsReducer;
